/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const MESSAGES = {
  DESCRIPTION_INFO: "Description of the module.",
  SERVICE_ID_INFO: "Unique identifier for the module.",
  MODULE_NAME_INFO: `A Module Display Name is equivalent to a product name in the Master Data Management (MDM) system visible in the Product Information Dashboard. Contact the application's Product Manager if you need the product name.
  
  Module DisplayName should contain only alphanumeric characters, hyphens, and spaces.
  `,
  SERVICE_ID_REQUIRED: "Service ID is required.",
  MODULE_NAME_REQUIRED: "Module name is required.",
  SERVICE_ID_INVALID: "Service ID is invalid.",
  MODULE_KEY_INVALID: "Module key is invalid.",
  DESCRIPTION_REQUIRED: "Description is required.",
  MODULE_KEY_INFO: `Module key is a unique identifier for the module and can't be changed later. Module Key should contain only lowercase alphabets (a-z). Max length is 8 characters.`,
  MODULE_KEY_REGEX: /^[a-z]+$/,
  MODULE_KEY_ALLOWED_CHARACTERS: "Module key should contain only lowercase alphabets (a-z).",
  MAX_MODULE_KEY_LENGTH: "Module Key cannot exceed 8 characters.",
};

export const TITLE = {
  SAVE: "Save",
  CANCEL: "Cancel",
  DESCRIPTION: "Description",
  ADD_MODULE: "Add Module",
  EDIT_MODULE: "Edit Module",
  MODULE_NAME: "Module Display Name",
  SERVICE_ID: "Service ID",
  MODULE_KEY: "Module Key"
};
